import { envValue, type EnvRecord } from "./envPreflight";

/**
 * U3 QUALIFY. The lead score's switch, shadow first, one rule for both the API
 * (which queues `lead.score` after each customer message) and the worker
 * (which writes the `lead.scored` row). Off, which is the default, the API
 * queues nothing and a queued task completes with a skipped ledger row and no
 * score. On is exactly "1"; unset, empty or "0" is off; anything else is
 * refused rather than guessed. Turning it on is Kabir's. The score gates
 * nothing whether on or off (CLAUDE.md section 0.5 and the U3 brief).
 */

export const ENABLE_LEAD_SCORE_ENV = "ACKRA_ENABLE_LEAD_SCORE";

/** Null when the value is a valid flag, or the problem sentence. Never quotes the value. */
export function validateEnableLeadScore(raw: string): string | null {
  if (raw === "0" || raw === "1") return null;
  return 'must be exactly "1" (the lead score on) or "0" (off). Any other value is refused rather than read as on';
}

/** True when the flag, read as set, is exactly "1". */
export function leadScoreRequested(env: EnvRecord): boolean {
  return envValue(env, ENABLE_LEAD_SCORE_ENV) !== undefined && env[ENABLE_LEAD_SCORE_ENV] === "1";
}

export function planLeadScore(env: EnvRecord): boolean {
  if (envValue(env, ENABLE_LEAD_SCORE_ENV) === undefined) return false;
  const complaint = validateEnableLeadScore(env[ENABLE_LEAD_SCORE_ENV] ?? "");
  if (complaint !== null) throw new Error(`${ENABLE_LEAD_SCORE_ENV} ${complaint}.`);
  return env[ENABLE_LEAD_SCORE_ENV] === "1";
}
